import React from "react";
import { useParams, Link } from "react-router-dom";
import blogPosts from "./blogData";
import "./BlogDetail.css";

function BlogDetail() {
  const { id } = useParams();
  const blog = blogPosts.find((post) => post.id === parseInt(id));

  if (!blog) return <p>Blog not found</p>;

  return (
    <div className="blog-detail">
      <div className="back-link">
        <Link to="/blogs">← Back to Blogs</Link>
      </div>
      <h1>{blog.title}</h1>
      {blog.image && <img src={blog.image} alt={blog.title} className="blog-image" />}
      <p className="blog-content">{blog.content}</p>
    </div>
  );
}

export default BlogDetail;
